import styled from "styled-components";

export const HomeWrapper = styled.div`

 height: 100vh;

 .ant-card{
   padding: 0 10px !important;
   background-color: rgba(0,0,0, 0.3) !important;
   backdrop-filter: blur(4px) !important;
   border-radius: 8px;
   border: none !important;
 }
`;

export const HeaderContainer = styled.div`
  height: 64px;
  width: 100%;
  border-bottom: 1px solid #e2e8f0;
  position: relative;
  background-color: #ffffff;

  .custom-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 24px;
`;

export const LogoContainer = styled.div`
  width: 150px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  //   @media (max-width: 1028px) {
  //     display: none;
  //   }

  a {
    color: #374151;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.875rem;
    transition: color 0.3s ease;

    &:hover,
    &:active {
      color: #8a3ef4 !important;
      font-weight: 600;
    }
  }
`;
